module.exports = __webpack_public_path__ + "img/5.bf951028.png";